import React from 'react';
import PropTypes from 'prop-types';

class GridRow extends React.Component {
  constructor(props) {
    super(props);
    this.displayName = 'GridRow';
  }
  getName() {
    return 'GridRow';
  }
  componentWillMount() {

  }
  extract(data, schemeProp) {
    let pieces = schemeProp.split('.');
    if(pieces.length == 1) {
      return data[pieces[0]];
    }
    if(typeof data === 'object')  {
      while(typeof data === 'object' && pieces.length > 0) {
        data = data[pieces.shift()]
      }
    }

    return data;
  }
  render() {

    let index = this.props.index || 0;
    let data = this.props.data || {};
    let schema = this.props.schema ? this.props.schema.filter(scheme => (scheme.prop && scheme.label)) : [];

    if(schema.length == 0)
      schema = Object.getOwnPropertyNames(data).map(name => ({prop : name, label : name}));
    if(schema.length == 0)
      return <td>No data provided.</td>;

    return <tr className={this.props.className}>{schema.map((scheme, i) => {
            const Component = scheme.component || null;
            if(Component)
              return <td key={i}><Component data={data} cell={this.extract(data, scheme.prop)} index={index} scheme={scheme} schemeIndex={i} /></td>
            return <td key={i}>{this.extract(data, scheme.prop) || ''}</td>
          })}</tr>;
  }
}

GridRow.propTypes = {
  schema : PropTypes.array,
  data : PropTypes.object,
  index : PropTypes.number.isRequired
}

export default GridRow;



// WEBPACK FOOTER //
// ./src/browser/components/ui/table/gridRow.js